// extracted by mini-css-extract-plugin
export default {"container":"product-reviews__container___94o5_","review-tire-button":"product-reviews__review-tire-button___3Qgmi"};